/* Shared, instance-safe lazy video lifecycle for all SN sections. */
(() => {
  if (window.SNCore) { window.SNCore.init(document); return; }
  const videos = new Set(), visible = new WeakSet();
  const hydrate = (video) => {
    if (video.dataset.snVideoReady === 'true') return;
    video.dataset.snVideoReady = 'true';
    if (video.dataset.poster) video.poster = video.dataset.poster;
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src; source.removeAttribute('data-src');
    });
    video.load();
  };
  const sync = (video) => {
    if (!video.isConnected) { observer?.unobserve(video); videos.delete(video); return; }
    if (document.hidden || !visible.has(video)) { video.pause(); return; }
    hydrate(video);
    if (video.dataset.snAutoplay === 'true') video.play()?.catch(() => {});
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target);
      sync(entry.target);
    });
  }) : null;
  function init(root = document) {
    const found = [...(root.querySelectorAll?.('[data-sn-lazy-video]') || [])];
    if (root.matches?.('[data-sn-lazy-video]')) found.unshift(root);
    found.forEach((video) => {
      if (videos.has(video)) return;
      videos.add(video);
      if (observer) observer.observe(video);
      else { visible.add(video); sync(video); }
    });
  }
  window.SNCore = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    videos.forEach((video) => {
      if (!event.target.contains(video)) return;
      video.pause(); observer?.unobserve(video); videos.delete(video); visible.delete(video);
    });
  });
  document.addEventListener('visibilitychange', () => videos.forEach(sync));
  window.addEventListener('pageshow', () => videos.forEach(sync));
})();
